module.exports = __webpack_public_path__ + "static/full08-bd54af14c215e4280a00dd822f5b3177.png";